/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Companion_S3Inputs */

const en_lg_companion_s3 = /** @type {(inputs: Lg_Companion_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review your selection and approve adding the link to the draft. Review the draft in Calendar; you decide when to save or send invitations. A meeting link does not grant new access.`)
};

const id_lg_companion_s3 = /** @type {(inputs: Lg_Companion_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau pilihan dan setujui penambahan tautan ke draf. Periksa lagi draf di Calendar; kamu sendiri yang menyimpan atau mengirim undangan. Tautan rapat tidak memberikan izin akses baru.`)
};

/**
* | output |
* | --- |
* | "Review your selection and approve adding the link to the draft. Review the draft in Calendar; you decide when to save or send invitations. A meeting link doe..." |
*
* @param {Lg_Companion_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_companion_s3 = /** @type {((inputs?: Lg_Companion_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Companion_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_companion_s3(inputs)
	return en_lg_companion_s3(inputs)
});